import { __rest } from "tslib";
import React, { forwardRef, useEffect, useRef } from 'react';
import { createReactWrapper } from '../../common/PrefixUtils';
import { handleForwardRef } from '../../common/RefUtils';
import { addExtraProps } from '../../common/utils/AddExtraProps';
export const NavigationDrawerItem = forwardRef((_a, ref) => {
    var { start, end, children, onChange, onClick, onKeyDown, onAction } = _a, props = __rest(_a, ["start", "end", "children", "onChange", "onClick", "onKeyDown", "onAction"]);
    const navigationDrawerItemRef = useRef();
    const handledRef = handleForwardRef(navigationDrawerItemRef, ref);
    const handleOnChangeEvent = (event) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
    };
    const handleOnClickEvent = (event) => {
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    };
    const handleOnKeyDownEvent = (event) => {
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
    };
    const handleActionHandler = (event) => {
        onAction === null || onAction === void 0 ? void 0 : onAction(event);
    };
    useEffect(() => {
        var _a, _b, _c, _d;
        (_a = navigationDrawerItemRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('change', handleOnChangeEvent);
        (_b = navigationDrawerItemRef.current) === null || _b === void 0 ? void 0 : _b.addEventListener('click', handleOnClickEvent);
        (_c = navigationDrawerItemRef.current) === null || _c === void 0 ? void 0 : _c.addEventListener('keydown', handleOnKeyDownEvent);
        (_d = navigationDrawerItemRef === null || navigationDrawerItemRef === void 0 ? void 0 : navigationDrawerItemRef.current) === null || _d === void 0 ? void 0 : _d.addEventListener('nav-drawer-action', handleActionHandler);
        return () => {
            var _a, _b, _c, _d;
            (_a = navigationDrawerItemRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('change', handleOnChangeEvent);
            (_b = navigationDrawerItemRef.current) === null || _b === void 0 ? void 0 : _b.removeEventListener('click', handleOnClickEvent);
            (_c = navigationDrawerItemRef.current) === null || _c === void 0 ? void 0 : _c.removeEventListener('keydown', handleOnKeyDownEvent);
            (_d = navigationDrawerItemRef === null || navigationDrawerItemRef === void 0 ? void 0 : navigationDrawerItemRef.current) === null || _d === void 0 ? void 0 : _d.removeEventListener('nav-drawer-action', handleActionHandler);
        };
    }, [ref, onChange, onClick, onKeyDown, onAction]);
    return createReactWrapper({
        tagName: 'chameleon-navigation-drawer-item',
        children: (React.createElement(React.Fragment, null,
            start && addExtraProps(start, { slot: 'start' }),
            children,
            end && addExtraProps(end, { slot: 'end' }))),
        props: Object.assign(Object.assign({}, props), { ref: handledRef }),
    });
});
